export namespace FilterPanelTypes {

    export interface PanelSettingsStorage{
        sectionVisibilitySettings: Array<UserDisplaySettings>
    }
    export interface PanelConfig {
        format: FilterPanelFormat;
        title?: string;
        name: string;
        sectionSorting: boolean;
        sections: Array<SectionConfig>;
        hideSectionsIfSingle?: boolean;
        buttonConfig?: ButtonConfig
        collapsible?: boolean;
        isCollapsed?: boolean;
    }

    export interface ValueChangeNotice {
        name: string;
        option: string;
        optionValue: string;
        toggleSelected: boolean;
    }

    export interface ButtonConfig {
        buttonLabel: string;
        buttonIconClass: string;
        buttonClassesEnabled: string;
        buttonClassesDisabled: string;
    }

    export interface Section<T> {
        config: SectionConfig;
        widget: T;
        valid: boolean;
    }

    export interface SectionConfig {
        sectionLabel: string;
        name: string;
        infoText?: string;
        options: Array<OptionConfig>;
        rules: SectionRules;
        collapsible?: boolean;
        isCollapsed?: boolean;
        hideable?: boolean;
        visibleByDefault?: boolean;
        order: number;
        widthLarge?: string;
        widthMedium?: string;
        widthSmall?: string;
        updateFunction?: string;
        leadingOptions?: Array<string>;
    }

    export interface UserDisplaySettings {
        filterpanelName: string
        sections: Array<UserSectionSetting>;
    }

    export interface UserSectionSetting {
        name: string,
        isCollapsed: boolean | "default";
        hidden: boolean | "default";
        order: number;
    }

    export interface FilterOptionRules {
        minSelectedCount?: number;
    }

    export interface SectionRules {
        minSelectedCount?: number;
        maxSelectedCount?: number;
    }
    export interface DynamicSectionUpdate {
        updateresult: Record<string, Partial<OptionConfig>>;
    }
    export interface OptionConfig {
        name: string;
        type: string;
        label: string;
        infoText?: string;
        value: string | number | boolean | Array<string>;
        selected: boolean;
        isMandatory: boolean;
        maxLength?: number;
        minLength?: number;
        minValue?: number;
        maxValue?: number;
        data?: { value?: any, selected?: boolean };
        emptyValueIfDeselected?: boolean;
        valueList?: Array<{ value: string, label: string, disabled: boolean, selected?: boolean, colorBG?: string, colorTXT?: string }>;
    }
}

export enum FilterOptionTypes {
    toggleButton = "toggleButton",
    combobox = "combobox",
    //checkbox = "checkbox", //sinnlos -> togglebutton kanns gleiche
    multiselect = "multiselect",
    date = "date",
    datetime = "datetime",
    text = "text",
    multilinetext = "multilinetext",
    number = "number",
    float = "float",
    infotext = "infotext",
    dualcolor = "dualcolor",
    simplecolor = "simplecolor",
    htmledit = "htmledit",
    hintbox = "hintbox"
}

export enum FilterPanelFormat {
    compact = "compact",
    default = "default"
}

